import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Card, CardBody } from 'reactstrap';

import Breadcrumbs from '../../components/Breadcrumb';
import LoadingOverlay from '../../components/LoadingOverlay';

function ProfitabilityPage() {
  const { showLoadingOverlay } = useSelector((state) => state.LoadingOverlay);

  const [pageTitle, setPageTitle] = useState('רווחיות');
  const [breadcrumbItems, setBreadcrumbItems] = useState([
    { title: 'רווחיות', link: '#' },
  ]);

  return (
    <React.Fragment>
      <Breadcrumbs title={pageTitle} breadcrumbItems={breadcrumbItems} />

      <Card className="card-box">
        {showLoadingOverlay && <LoadingOverlay />}

        <CardBody>
          <Outlet context={[setPageTitle, setBreadcrumbItems]} />
        </CardBody>
      </Card>
    </React.Fragment>
  );
}

export default ProfitabilityPage;
